export const updateFormState = (payload) => ({
    type: 'UPDATE_ORDERS_FILTERS_FORM',
    payload
}); 


// WEBPACK FOOTER //
// ./src/components/Pages/Commissions/actions.js